import { render, staticRenderFns } from "./CatalogProductSingleContainer.vue?vue&type=template&id=77d628c7&scoped=true&"
import script from "./CatalogProductSingleContainer.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSingleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d628c7",
  null
  
)

export default component.exports